import { useQuery } from '@tanstack/react-query'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

import { scrollAppPageToTop } from '@/pages/_app/utils'

import { getNotificationHistoryQuery } from '@/lib/queries/notification/v1/history/queries'
import { NotificationType } from '@/lib/queries/notification/v1/history/types'

import { DOM_ID } from '../../../constants'

export const useCaseUpdateHistory = () => {
  const [paginationPortalRoot, setPaginationPortalRoot] = useState<HTMLElement | null>(null)

  const navigate = useNavigate()
  const searchParams = useSearch({
    from: '/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-update-history',
  })

  const currentPage = searchParams.page
  const currentPageSize = searchParams.pageSize ?? 10
  const searchKeyword = searchParams.keyword
  const assignees = searchParams.assignees?.map((v) => Number(v))
  const assigneeCondition = searchParams.assigneeCondition

  const { data: caseUpdateHistoryData, isLoading: isLoadingData } = useQuery(
    getNotificationHistoryQuery({
      pageNumber: currentPage,
      pageSize: currentPageSize,
      notificationType: NotificationType.CASE_UPDATES,
      keyword: searchKeyword,
      assignees,
      assigneeCondition,
    })
  )

  const handleChangePage = (page: number) => {
    void navigate({
      to: '/dashboard/case-updates/case-update-history',
      search: {
        ...searchParams,
        page,
      },
    })

    scrollAppPageToTop()
  }

  const handleChangePageSize = (pageSize: number) => {
    void navigate({
      to: '/dashboard/case-updates/case-update-history',
      search: {
        ...searchParams,
        page: 1,
        pageSize,
      },
    })

    scrollAppPageToTop()
  }

  useEffect(function attachPagination() {
    const caseUpdateHistoryPaginationPortalRoot = document.getElementById(DOM_ID.caseUpdatesPaginationPortal)
    setPaginationPortalRoot(caseUpdateHistoryPaginationPortalRoot)
  }, [])

  return {
    caseUpdateHistoryData: caseUpdateHistoryData?.result ?? [],
    totalPages: caseUpdateHistoryData?.totalPages ?? 0,
    currentPage,
    currentPageSize,
    paginationPortalRoot,
    isLoadingData,
    handleChangePage,
    handleChangePageSize,
  }
}
